import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (enquiries) => {
  if (!enquiries || enquiries.length === 0) {
    alert("No data to export");
    return;
  }

  // Map data into a simple array of objects
  const dataToExport = enquiries.map((enquiry) => ({
    "Enquiry ID": enquiry.enquiryid,
    Date: new Date(enquiry.date).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).replace(",", ""),
    Name: enquiry.username,
    Mobile: enquiry.mobile,
    Email: enquiry.email,
    Subject: enquiry.subject,
    Message: enquiry.message,
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Enquiries");

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(file, "Enquiries.xlsx");
};
